import React, { useState, useEffect, useRef } from "react";
import { Dimmer } from "../spinner";
import { formatMoneda } from "../../util/varios";
import "react-tabs/style/react-tabs.css";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import moment from "moment";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import CatalogoVerificarPersona from "../../catalogos/catalogoVerifipersona";
import { ActualizarPagosWeb } from "./modalActuVerificacion";
import useTableScroll from "../useTableScrollcesar";

function TablaVerificarPagos() {
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const op = require("../../../public/modulos/datos");
  const anioActu = JSON.parse(localStorage.getItem("anioactu"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const idusu = JSON.parse(localStorage.getItem("idusuario"));
  const anio = JSON.parse(localStorage.getItem("anioactu"));

  const headCells = [
    {
      label: (
        <input
          type="checkbox"
          checked={checkedAll}
          disabled={desabilitarRows2}
          onChange={handleSelectAllClick}
        />
      ),
      width: "50px",
      textAlign: "center",
    },
    { label: "Cuenta Bancaria", width: "250px", textAlign: "center" },
    { label: "Documento", width: "50px", textAlign: "center" },
    { label: "Tipo", width: "50px", textAlign: "center" },
    { label: "Fecha Pago", width: "120px", textAlign: "center" },
    { label: "Monto", width: "60px", textAlign: "center" },
    { label: "Factura", width: "100px", textAlign: "center" },
    { label: "Contribuyente", width: "250px", textAlign: "center" },
    { label: "Periodo", width: "50px", textAlign: "center" },
    { label: "Fecha Operación", width: "120px", textAlign: "center" },
    { label: "Opción", width: "50px", textAlign: "center" },
  ];

  const txtAccion = useRef();
  const txtEdit = useRef();
  const txtPrefactura = useRef();
  const btnCancela = useRef();
  const btnBuscar = useRef();
  const txtTotal = useRef("0,00");
  const cmbTipoImpuesto = useRef();
  const cmbCuentaBan = useRef();
  const txtFechaDesde = useRef();
  const txtFechaHasta = useRef();
  const radioTodosBancos = useRef();
  const radioSeleccionarBanco = useRef();
  const radioTodosDias = useRef();
  const radioSeleccionarFecha = useRef();

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [liquidador, setLiquidador] = useState("");
  const [fechaVerifi, setFechaVerifi] = useState("");
  const [idusuario, setIdUsuario] = useState("");
  const [select, setSelect] = useState("0");
  const [select2, setSelect2] = useState("0");
  const [select3, setSelect3] = useState("0");
  const [val, setVal] = useState();
  const [cuentaBancaria, setCuentaBancaria] = useState();
  const [mostrarCatalogo, setMostrarCatalogo] = useState(false);
  const [activo, setActivo] = useState(true);
  const [activo1, setActivo1] = useState(true);
  const [activo2, setActivo2] = useState(true);
  const [mostrar5, setMostrar5] = useState(false);
  const [idtipoingreso, setIdtipoingreso] = useState("");
  const [contar4, setContar4] = useState(0);
  const [activate, setActivate] = useState(false);
  const [data, setData] = useState();
  const [operacion, setOperacion] = useState(0);
  const [tipoImpuesto, setTipoImpuesto] = useState();
  const [tipoimpu, setTipoimpu] = useState();
  const [efectivo, setEfectivo] = useState(true);
  const [desabilitarRows, setDesabilitarRows] = useState(false);
  const [desabilitarRows2, setDesabilitarRows2] = useState(false);
  const [banco, setBanco] = useState(false);
  const [verificacion, setVerificacion] = useState("");
  const [contar, setContar] = useState(0);
  const [tipoPago, setTipoPago] = useState();
  const [usuario, setUsuario] = useState();
  const [idVerificacion, setIdVerificacion] = useState();
  const [cedulaR, setCedula] = useState();
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [selected, setSelected] = useState([]);
  const [movSelected, setMovSelected] = useState([]);
  const [factuSelected, setFactuSelected] = useState([]);
  const [disabletbtn, setDisabletbtn] = useState({
    consultar: false,
    verificar: false,
    rechazar: false,
    editar: false,
  });
  const [checkedAll, setCheckedAll] = useState(false);

  const handleSelectAllClick = (event) => {
    if (verificacion !== 4) {
      if (event.target.checked) {
        setCheckedAll(true);
        const newSelecteds = records.map(
          (n) =>
            n.nrofactura.trim() +
            n.periodo.trim() +
            n.nrodocumento.trim() +
            n.monto.toString().trim()
        );
        setSelected(newSelecteds);
        const newFacSelecteds = records.map((n) => n.nrofactura.trim());
        setFactuSelected(newFacSelecteds);
        sumarMontoFactura(newSelecteds);
        return;
      } else {
        setCheckedAll(false);
        setSelected([]);
        setFactuSelected([]);
        sumarMontoFactura([]);
      }
    }
  };

  const handleClick = (event, id, fact) => {
    if (verificacion !== 4) {
      const selectedIndex = selected.indexOf(id);
      const selectedFactIndex = factuSelected.indexOf(fact);
      let newSelected = [];
      let newFactSelected = [];

      if (selectedIndex === -1) {
        newSelected = newSelected.concat(selected, id);
        newFactSelected = newFactSelected.concat(factuSelected, fact);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
        newFactSelected = newFactSelected.concat(factuSelected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
        newFactSelected = newFactSelected.concat(factuSelected.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          selected.slice(0, selectedIndex),
          selected.slice(selectedIndex + 1)
        );
        newFactSelected = newFactSelected.concat(
          factuSelected.slice(0, selectedFactIndex),
          factuSelected.slice(selectedFactIndex + 1)
        );
      }

      setSelected(newSelected);
      setFactuSelected(newFactSelected);
      sumarMontoFactura(newSelected);
    }
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;
  const { TblContainer, TblHead } = useTableScroll(headCells);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            x.contribuyente = x.contribuyente !== null ? x.contribuyente : "";

            if (
              x.cuentabancaria.includes(target.value) ||
              x.nrodocumento.includes(target.value.toLowerCase()) ||
              x.tipo.toLowerCase().includes(target.value.toLowerCase()) ||
              moment(x.fecha)
                .format("DD/MM/YYYY")
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              formatMoneda(x.monto.toString().replace(".", ","), ",", ".", 2)
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.nrofactura.toLowerCase().includes(target.value.toLowerCase()) ||
              x.idcontribuyente.includes(target.value.toLowerCase()) ||
              x.contribuyente
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.periodo.toLowerCase().includes(target.value.toLowerCase()) ||
              moment(x.fechaoperacion)
                .format("DD/MM/YYYY")
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const rechazarVerificar = (opcion) => (e) => {
    setDisabletbtn({
      ...disabletbtn,
      consultar: true,
      verificar: true,
      rechazar: true,
      editar: true,
    });
    setActivo1(false);
    setActivo(false);
    if (opcion === 1) {
      cmbTipoImpuesto.current.value = 1;
      seleccionarConfiguracion();
    } else {
      setDesabilitarRows(true);
    }
    setVerificacion(opcion);
    e.preventDefault();
    seleccionarTipoImpuesto();
  };

  const SelectCuentaBanco = () => {
    let endpoint = `${
      op.conexion
    }/api/Caja_Ingreso/selectallcuentabancarias?depositoweb=${true}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setActivate(false);
          if (response.data.length > 0) {
            setCuentaBancaria(response.data);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const selectTipoImpu = (pagosweb) => {
    let endpoint = `${op.conexion}/api/Caja_Ingreso/selectalltipoimpuesto?pagosweb=${pagosweb}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setTipoImpuesto(response.data);
            setContar(contar + 1);
            if (response.data.idtipoingreso) {
              if (cmbTipoImpuesto.current !== undefined) {
                cmbTipoImpuesto.current.value = response.data[0].idtipoingreso;
              }
            } else {
              if (cmbTipoImpuesto.current !== undefined) {
                cmbTipoImpuesto.current.value = response.data[0].idtipoingreso;
              }
              seleccionarPagosAVerificar(response.data[0].idtipoingreso);
            }
          } else {
            setTipoImpuesto([]);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const selectPagosVerify = (id, condic) => {
    setIdUsuario(JSON.parse(localStorage.getItem("idusuario")));
    setFechaVerifi(JSON.parse(localStorage.getItem("fechasistema")));
    SelecccionarUsuario();

    let endpoint = `${op.conexion}/api/Caja_Ingreso/selectpagosaverify?id=${id}&condic=${condic}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setActivate(false);
          if (response.data.length > 0) {
            setRecords(response.data);
            setContar4(contar4 + 1);
          } else {
            setRecords([]);
          }
          setSelected([]);
          sumarMontoFactura([]);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const imprimirPlanilla = (idveri) => {
    var reporte = "";
    var verificador = liquidador === null ? "" : liquidador.trim();
    var cedula =
      cedulaR === null
        ? ""
        : formatMoneda(cedulaR.toString().replace(".", ","), ",", ".", 0);
    var id = parseInt(idveri);
    var fact = "V" + id.toString().padStart(7, 0);
    var factura = fact;

    reporte = "VerificacionCojedes";
    window.open(
      op.reportes +
        "reporte=" +
        reporte +
        "&verificador=" +
        verificador +
        "&cedula=" +
        cedula +
        "&id=" +
        id +
        "&factura=" +
        factura,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const seleccionarConfiguracion = () => {
    let endpoint;

    if (efectivo === true || cmbTipoImpuesto.current.value === "1") {
      endpoint = `${op.conexion}/api/minas/configuracionminas?nanio=${anio}`;
    } else if (cmbTipoImpuesto.current.value === "2") {
      endpoint = `${op.conexion}/api/produccion/configuracionproduccion?nanio=${anio}`;
    } else if (cmbTipoImpuesto.current.value === "3") {
      endpoint = `${op.conexion}/api/retencion/configuracion1x500?nanio=${anio}`;
    } else if (cmbTipoImpuesto.current.value === "4") {
      endpoint = `${op.conexion}/api/Caja_Ingreso/configuracionexpendedor?nanio=${anio}`;
    }

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.valorutMulta === null) {
            if (response.data.factormulta === 2) {
              setMensaje({
                mostrar: true,
                titulo: "Exito.",
                texto:
                  "El valor de la unidad tributaria para el año " +
                  anioActu +
                  " no esta definido",
                icono: "exito",
              });
            } else if (response.data.factormulta > 2) {
              let tipo = response.data.factormulta - 3;
              setMensaje({
                mostrar: true,
                titulo: "Exito.",
                texto:
                  "El valor del " +
                  (tipo === 0
                    ? "Petro"
                    : tipo === 1
                    ? "Sueldo Minimo"
                    : tipo === 2
                    ? "UCAMP"
                    : "") +
                  " para el año " +
                  anioActu +
                  " en el mes en curso no esta definido",
                icono: "exito",
              });
            }
          }

          if (efectivo === true) {
            setEfectivo(false);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SelecccionarUsuario = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "usuariotimbre";
    let nomid = "idusuario";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idusu}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idusuario > 0) {
            SelecccionarPersona(response.data);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SelecccionarPersona = (data) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.persona}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setUsuario(response.data);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const procesarVerificacion = (movi) => {
    let endpoint = `${op.conexion}/api/Caja_Ingreso/actualizarverificacion/${verificacion}`;

    let body;
    setActivate(true);

    body = {
      declaweb: true,
      fechasis: moment(fechaSistema).format("YYYY-MM-DD"),
      movimientos: JSON.stringify(movi),
      tipoimpu:
        verificacion === 5
          ? tipoimpu
          : cmbTipoImpuesto.current.value === "1"
          ? "MINAS"
          : cmbTipoImpuesto.current.value === "2"
          ? "PRODUCCIÓN"
          : cmbTipoImpuesto.current.value === "3"
          ? "1X500"
          : "TIMBRES FISCALES",
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (verificacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "La Factura con el Código" +
                " " +
                response.data.idverifi +
                " " +
                "fue Verificada Correctamente",
              icono: "exito",
            });
            imprimirPlanilla(response.data.idverifi);
          } else if (verificacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "La Factura con el Código" +
                " " +
                response.data.idverifi +
                " " +
                "fue Rechazada Correctamente",
              icono: "exito",
            });
          } else if (verificacion === 5) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "La Factura con el Código" +
                " " +
                response.data.idverifi +
                " " +
                "fue Eliminada Correctamente",
              icono: "exito",
            });
          }
          selectTipoImpu(1);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarTipoImpuesto = () => {
    setContar(0);
    selectTipoImpu(1);
  };

  const procesarSolicitud = () => {
    setContar(0);
    var veri = [];
    if (verificacion === 1 || verificacion === 2) {
      for (let x = 0; x < selected.length; x++) {
        for (let y = 0; y < records.length; y++) {
          if (
            records[y].nrofactura.trim() +
              records[y].periodo.trim() +
              records[y].nrodocumento.trim() +
              records[y].monto.toString().trim() ===
            selected[x]
          ) {
            veri.push({
              idverificacion:
                verificacion === 1 || verificacion === 2
                  ? 0
                  : records[y].idverificacion,
              idpagoweb: records[y].idpagoweb,
              idcuentabancaria: records[y].idcuentabancaria,
              fecha: records[y].fecha,
              cuentabancaria: records[y].cuentabancaria.trim(),
              nrodocumento: records[y].nrodocumento.trim(),
              tipo: records[y].tipotransaccion,
              nrofactura: records[y].nrofactura.trim(),
              monto: records[y].monto,
              idcontribuyente: records[y].idcontribuyente,
              contribuyente:
                records[y].contribuyente !== null
                  ? records[y].contribuyente
                  : "-",
              periodo: records[y].periodo.trim(),
              idverificador:
                verificacion === 1 || verificacion === 2
                  ? idusuario
                  : records[y].idverificador,
              montototal: txtTotal.current.value
                .replace(/\./g, "")
                .replace(",", "."),
              fechaverificacion: fechaSistema,
              idfactura: records[y].idfactura,
              idtipoingreso: records[y].idtipoingreso,
              tabla: records[y].tabla.trim(),
              montomulta: records[y].montomulta,
              montorecargo: records[y].montorecargo,
              montointereses: records[y].montointereses,
              montoimpuesto: records[y].montoimpuesto,
              montodeducible: records[y].montodeducible,
              totalfactura: txtTotal.current.value
                .replace(/\./g, "")
                .replace(",", "."),
              deudas:
                records[y].idpublicidad === null
                  ? ""
                  : "'" + records[y].idpublicidad + "'",
              fechaoperacion: records[y].fechaoperacion,
            });
            break;
          }
        }
      }
    } else if (verificacion === 5) {
      var noexiste;
      for (let z = 0; z < movSelected.length; z++) {
        noexiste = true;
        for (let x = 0; x < selected.length; x++) {
          if (selected[x] === movSelected[z]) {
            noexiste = false;
            break;
          }
        }
        if (noexiste) {
          for (let y = 0; y < records.length; y++) {
            if (
              records[y].nrofactura.trim() +
                records[y].periodo.trim() +
                records[y].nrodocumento.trim() +
                records[y].monto.toString().trim() ===
              movSelected[z]
            ) {
              veri.push({
                idverificacion: records[y].idverificacion,
                idpagoweb: records[y].idpagoweb,
                idcuentabancaria: records[y].idcuentabancaria,
                fecha: records[y].fecha,
                cuentabancaria: records[y].cuentabancaria.trim(),
                nrodocumento: records[y].nrodocumento.trim(),
                tipo: records[y].tipo,
                nrofactura: records[y].nrofactura.trim(),
                monto: records[y].monto,
                idcontribuyente: records[y].idcontribuyente,
                contribuyente: records[y].contribuyente.trim(),
                periodo: records[y].periodo.trim(),
                idverificador:
                  verificacion === 1 || verificacion === 2
                    ? idusuario
                    : records[y].idverificador,
                montototal: txtTotal.current.value
                  .replace(/\./g, "")
                  .replace(",", "."),
                fechaverificacion: fechaSistema,
                idfactura: records[y].idfactura,
                idtipoingreso: records[y].idtipoingreso,
                tabla: records[y].tabla.trim(),
                montomulta: records[y].montomulta,
                montorecargo: records[y].montorecargo,
                montointereses: records[y].montointereses,
                montoimpuesto: records[y].montoimpuesto,
                montodeducible: records[y].montodeducible,
                totalfactura: txtTotal.current.value
                  .replace(/\./g, "")
                  .replace(",", "."),
                deudas: records[y].deudas,
              });
              break;
            }
          }
        }
      }
    }
    console.log(veri);
    procesarVerificacion(veri);
  };

  const onChangeValidar = () => {
    var sigue = true;
    if (verificacion === 1 || verificacion === 2 || verificacion === 5) {
      if (selected.length === 0 && (verificacion === 1 || verificacion === 2)) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Usted no ha marcado ningun Item!",
          icono: "informacion",
        });
        btnCancela.current.focus();
        sigue = false;
      } else if (selected.length === records.length && verificacion === 5) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Usted no ha marcado ningun Item!",
          icono: "informacion",
        });
        btnCancela.current.focus();
        sigue = false;
      } else {
        var search;
        var occurrences;
        var occurrences1;
        for (let i = 0; i < factuSelected.length; i++) {
          search = factuSelected[i].trim().toLowerCase();
          occurrences = factuSelected.filter(function (val) {
            return val.trim().toLowerCase() === search;
          }).length;
          occurrences1 = records.filter(function (val) {
            return val.nrofactura.trim().toLowerCase() === search;
          }).length;
          if (occurrences !== occurrences1) {
            setMensaje({
              mostrar: true,
              titulo: "Error",
              texto:
                "La Factura " +
                factuSelected[i] +
                " Posee mas de una Operacion, debe verificar todas las operaciones de una misma factura para poder procesar esa factura.",
              icono: "error",
            });
            sigue = false;
            break;
          }
        }
      }
    }

    if (sigue && verificacion !== 4) {
      if (verificacion === 1) {
        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto:
            "¿Esta Seguro de Procesar estos Movimientos como Verificados ?",
          icono: "confirmacion",
        });
      } else if (verificacion === 2) {
        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto: "¿Esta Seguro de Procesar estos Movimientos como Rechazados ?",
          icono: "confirmacion",
        });
      } else if (verificacion === 5) {
        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto:
            "¿Esta Seguro de Eliminar estos Movimientos de la Verificación ??",
          icono: "confirmacion",
        });
      }
    }
  };

  const blanquear2 = () => {
    setSelected([]);
    setFactuSelected([]);
    setRecords([]);
    setTipoImpuesto();
    setVerificacion("");
    setDisabletbtn({
      ...disabletbtn,
      consultar: false,
      verificar: false,
      rechazar: false,
      editar: false,
    });
    setLiquidador("");
    setIdUsuario("");
    setFechaVerifi("");
    setUsuario("");
    setDesabilitarRows(false);
    setDesabilitarRows2(false);
    setBanco(false);
    setSelect("0");
    setSelect2("0");
    setSelect3("0");
    setActivo(true);
    setActivo1(true);
    setActivo2(true);
  };

  const cancelar = () => {
    blanquear2();
    seleccionarPagosAVerificar(0);
    radioTodosBancos.current.checked = true;
    radioTodosDias.current.checked = true;
    radioSeleccionarFecha.current.checked = "";
    radioSeleccionarBanco.current.checked = "";
    txtPrefactura.current.value = "";
    txtTotal.current.value = "0,00";
  };

  const seleccionarPagosAVerificar = (idtiping) => {
    setContar(0);
    setActivate(true);

    let ingreTipo = idtiping;
    if (idtiping === "1") {
      ingreTipo = "1, 11, 19, 20, 21";
    } else if (idtiping === "2") {
      ingreTipo = "2, 12";
    } else if (idtiping === "3") {
      ingreTipo = "3, 13";
    }

    let sql;
    let sql1 = ` AND idtipoingreso in (${ingreTipo})`;
    let ids =
      banco === false
        ? "p.idcuentabancaria > 0"
        : "p.idcuentabancaria =" + cmbCuentaBan.current.value;

    if (radioSeleccionarFecha.current.checked) {
      let val2 =
        txtFechaDesde.current.value === ""
          ? "now()"
          : txtFechaDesde.current.value;

      let val3 =
        txtFechaHasta.current.value === ""
          ? "now()"
          : txtFechaHasta.current.value;

      sql =
        " where  Fecha Between" +
        "'" +
        val2 +
        "'" +
        " AND " +
        "'" +
        val3 +
        "' " +
        sql1;
    } else {
      sql = " WHERE true " + sql1;
    }

    selectPagosVerify(ids, sql);
  };

  const handlecmbTipoImpuesto = (event) => {
    event.preventDefault();
    let tipo = (cmbTipoImpuesto.current.value = ""
      ? 1
      : cmbTipoImpuesto.current.value);

    let ingreTipo = tipo;
    if (tipo === "1") {
      ingreTipo = "1, 11, 19, 20, 21";
    } else if (tipo === "2") {
      ingreTipo = "2, 12";
    } else if (tipo === "3") {
      ingreTipo = "3, 13";
    }

    let sql;
    let sql1 = ` AND idtipoingreso in (${ingreTipo})`;
    let idss = "p.idcuentabancaria > 0";

    sql = " WHERE true " + sql1;

    if (cmbTipoImpuesto.current.value === "1") {
      seleccionarConfiguracion();
      setSelect("0");
      setSelect2("0");
      selectPagosVerify(idss, sql);
      radioTodosDias.current.checked = true;
      radioTodosBancos.current.checked = true;
      radioSeleccionarFecha.current.checked = "";
      radioSeleccionarBanco.current.checked = "";
    } else if (cmbTipoImpuesto.current.value === "2") {
      seleccionarConfiguracion();
      setSelect("0");
      setSelect2("0");
      selectPagosVerify(idss, sql);
      radioTodosDias.current.checked = true;
      radioTodosBancos.current.checked = true;
      radioSeleccionarFecha.current.checked = "";
      radioSeleccionarBanco.current.checked = "";
    } else if (cmbTipoImpuesto.current.value === "3") {
      seleccionarConfiguracion();
      setSelect("0");
      setSelect2("0");
      selectPagosVerify(idss, sql);
      radioTodosDias.current.checked = true;
      radioTodosBancos.current.checked = true;
      radioSeleccionarFecha.current.checked = "";
      radioSeleccionarBanco.current.checked = "";
    } else if (cmbTipoImpuesto.current.value === "4") {
      seleccionarConfiguracion();
      setSelect("0");
      setSelect2("0");
      selectPagosVerify(idss, sql);
      radioTodosDias.current.checked = true;
      radioTodosBancos.current.checked = true;
      radioSeleccionarFecha.current.checked = "";
      radioSeleccionarBanco.current.checked = "";
    }
  };

  const handlecmbCuentaBancaria = (event) => {
    setBanco(true);
    event.preventDefault();
    let ids = "p.idcuentabancaria = " + event.target.value;
    selectPagosVerify(ids, val);
  };

  const editarMovimiento = (data) => (event) => {
    setOperacion(2);
    setData(data);
    setTipoPago(data.tipo === 1 ? "DEPOSITO" : "TRANSFERENCIA");
    setMostrar5(true);
  };

  const sumarMontoFactura = (regSelected) => {
    var total = parseFloat(0.0);
    for (let x = 0; x < regSelected.length; x++) {
      for (let y = 0; y < records.length; y++) {
        if (
          records[y].nrofactura.trim() +
            records[y].periodo.trim() +
            records[y].nrodocumento.trim() +
            records[y].monto.toString().trim() ===
          regSelected[x]
        ) {
          total = total + parseFloat(records[y].monto);
          break;
        }
      }
    }

    txtTotal.current.value = formatMoneda(
      total.toString().replace(".", ","),
      ",",
      ".",
      2
    );
  };

  const onChecks = (event) => {
    let ids = (cmbTipoImpuesto.current.value = ""
      ? 1
      : cmbTipoImpuesto.current.value);

    let ingreTipo = ids;
    if (ids === "1") {
      ingreTipo = "1, 11, 19, 20, 21";
    } else if (ids === "2") {
      ingreTipo = "2, 12";
    } else if (ids === "3") {
      ingreTipo = "3, 13";
    }

    let idss = "p.idcuentabancaria > 0";
    let sql;
    let sql1 = ` AND idtipoingreso in (${ingreTipo})`;
    let val2;
    let val3;

    if (event.target.name === "radiofecha") {
      if (radioTodosDias.current.checked) {
        setBanco(false);
        setSelect2("0");
        sql = " WHERE true " + sql1;
        selectPagosVerify(idss, sql);
      } else if (radioSeleccionarFecha.current.checked) {
        setSelect2("1");
        let fecha1 = moment(fechaSistema).format("YYYY-MM-DD");
        let fecha2 = moment(fechaSistema).format("YYYY-MM-DD");
        val2 =
          txtFechaDesde.current.value === fecha1
            ? "now()"
            : txtFechaDesde.current.value;
        val3 =
          txtFechaHasta.current.value === fecha2
            ? "now()"
            : txtFechaHasta.current.value;
        sql =
          " where  Fecha Between" +
          "'" +
          val2 +
          "'" +
          " AND " +
          "'" +
          val3 +
          "' " +
          sql1;
        selectPagosVerify(idss, sql);
      } else {
        setSelect2("0");
      }
    } else if (event.target.name === "radioBanco") {
      if (radioTodosBancos.current.checked) {
        setBanco(false);
        setSelect("0");
        sql = " WHERE true " + sql1;
        selectPagosVerify(idss, sql);
      } else if (radioSeleccionarBanco.current.checked) {
        setSelect("1");
        sql = " WHERE true " + sql1;
        setVal(sql);
      } else {
        setSelect("0");
      }
    }
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      if (event.target.id === "inputFechaDesde") {
        if (txtFechaDesde.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Fecha Invalida",
            icono: "informacion",
          });
        } else if (
          txtFechaDesde.current.value > txtFechaHasta.current.value &&
          txtFechaHasta.current.value !== ""
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto:
              "La fecha de inicio no puede ser superior a la fecha de fin.",
            icono: "informacion",
          });
        } else {
          seleccionarPagosAVerificar(cmbTipoImpuesto.current.value);
        }
      } else if (event.target.id === "inputFechaHasta") {
        if (txtFechaHasta.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Fecha Invalida",
            icono: "informacion",
          });
        } else if (
          txtFechaDesde.current.value > txtFechaHasta.current.value &&
          txtFechaHasta.current.value !== ""
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto:
              "La fecha de fin no puede ser inferior a la fecha de inicio.",
            icono: "informacion",
          });
        } else {
          seleccionarPagosAVerificar(cmbTipoImpuesto.current.value);
        }
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputFechaDesde") {
        if (txtFechaDesde.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Fecha Invalida",
            icono: "informacion",
          });
        } else if (
          txtFechaDesde.current.value > txtFechaHasta.current.value &&
          txtFechaHasta.current.value !== ""
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto:
              "La fecha de inicio no puede ser superior a la fecha de fin.",
            icono: "informacion",
          });
        } else {
          seleccionarPagosAVerificar(cmbTipoImpuesto.current.value);
        }
      } else if (event.target.id === "inputFechaHasta") {
        if (txtFechaHasta.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Fecha Invalida",
            icono: "informacion",
          });
        } else if (
          txtFechaDesde.current.value > txtFechaHasta.current.value &&
          txtFechaHasta.current.value !== ""
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto:
              "La fecha de inicio no puede ser superior a la fecha de fin.",
            icono: "informacion",
          });
        } else {
          seleccionarPagosAVerificar(cmbTipoImpuesto.current.value);
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const SelectVerificacion = (idverificacion) => {
    let endpoint = `${op.conexion}/api/Caja_Ingreso/selectverificacionbyid?idverificacion=${idverificacion}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setRecords(response.data);

            if (verificacion === 4 || verificacion === 5) {
              const newSelecteds = response.data.map(
                (n) =>
                  n.nrofactura.trim() +
                  n.periodo.trim() +
                  n.nrodocumento.trim() +
                  n.monto.toString().trim()
              );
              setSelected(newSelecteds);
              setMovSelected(newSelecteds);
              const newFacSelecteds = response.data.map((n) =>
                n.nrofactura.trim()
              );
              setFactuSelected(newFacSelecteds);
            }
          } else {
            setRecords([]);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const aceptarInfoCat = (
    idverificacion,
    idverificador,
    montototal,
    liquidador,
    prefactura,
    idtipoingreso,
    fechaverificacion,
    cedula,
    status
  ) => {
    if (verificacion === 5 && status === "1") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La verificación ya fue Pagada",
        icono: "informacion",
      });
    } else if (verificacion === 4 || verificacion === 5) {
      SelectVerificacion(idverificacion);
      if (idtipoingreso === 1 || idtipoingreso === 11 || idtipoingreso === 19 || idtipoingreso === 20|| idtipoingreso === 21) {
        setTipoimpu("MINAS");
      } else if (idtipoingreso === 2 || idtipoingreso === 12) {
        setTipoimpu("PRODUCCIÓN");
      } else if (idtipoingreso === 3 || idtipoingreso === 13) {
        setTipoimpu("1X1000");
      } else if (idtipoingreso === 4) {
        setTipoimpu("TIMBRES FISCALES");
      }

      setActivo(false);
      setActivo2(true);
    } else {
      setActivo(true);
      setActivo2(false);
      SelectVerificacion(idverificacion);
      setDesabilitarRows2(true);
      setIdVerificacion(idverificacion);
    }
    setCedula(cedula);
    setLiquidador(liquidador);
    setIdUsuario(idverificador);
    setFechaVerifi(fechaverificacion);
    txtPrefactura.current.value = idverificacion;
    setMostrarCatalogo(false);
    setSelect3("1");
    if (idtipoingreso === "1" || idtipoingreso === "11" || idtipoingreso === "19" || idtipoingreso === "20" || idtipoingreso === "21") {
      setIdtipoingreso("MINA");
    } else if (idtipoingreso === "2" || idtipoingreso === "12") {
      setIdtipoingreso("PRODUCCIÓN");
    } else if (idtipoingreso === "3" || idtipoingreso === "13") {
      setIdtipoingreso("1X1000");
    } else if (idtipoingreso === "4") {
      setIdtipoingreso("EXPENDEDORES");
    }
  };

  const handleBtnImprimir = (event) => {
    event.preventDefault();

    if (txtPrefactura.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Tabla Verificación esta Vacia.",
        icono: "error",
      });
    } else {
      imprimirPlanilla(idVerificacion);
    }
  };

  const cerrarModalActualizar = () => {
    setMostrar5(false);
  };

  const validarActuPagoW = () => {
    setMostrar5(false);
    seleccionarPagosAVerificar(cmbTipoImpuesto.current.value);
  };

  const abrirCatalogo = () => {
    if (verificacion === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "Esta opción esta Habilitada solo para Consultar o Editar una Verificación!...",
        icono: "informacion",
      });
      txtAccion.current.focus();
    } else {
      if (!mostrarCatalogo) {
        setMostrarCatalogo(true);
      } else {
        setMostrarCatalogo(false);
      }
    }
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarSolicitud();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (verificacion === 5) {
      SelectVerificacion(0);
      blanquear2();
      txtPrefactura.current.value = "";
    } else {
      let ids = (cmbTipoImpuesto.current.value = ""
        ? 0
        : cmbTipoImpuesto.current.value);

      let ingreTipo = ids;
      if (ids === "1") {
        ingreTipo = "1, 11, 19, 20, 21";
      } else if (ids === "2") {
        ingreTipo = "2, 12";
      } else if (ids === "3") {
        ingreTipo = "3, 13";
      }
      let sql;
      let sql1 = ` AND idtipoingreso in (${ingreTipo})`;
      let idss = "p.idcuentabancaria > 0";
      sql = " WHERE true " + sql1;
      selectPagosVerify(idss, sql);
      blanquear2();
    }
  };

  const accion = (ac) => (e) => {
    setActivo1(false);
    cmbTipoImpuesto.current.value = "";
    txtTotal.current.value = "0,00";
    setVerificacion(ac);
    setDesabilitarRows(true);
    setDisabletbtn({
      ...disabletbtn,
      consultar: true,
      verificar: true,
      rechazar: true,
      editar: true,
    });
    btnBuscar.current.focus();
    e.preventDefault();
  };

  const editar = (op) => (e) => {
    e.preventDefault();
    setActivo1(false);
    setDesabilitarRows(true);
    setVerificacion(op);
    setDisabletbtn({
      ...disabletbtn,
      consultar: true,
      verificar: true,
      rechazar: true,
      editar: true,
    });
  };

  useEffect(() => {
    SelectCuentaBanco();
    setDesabilitarRows(false);
  }, []);

  return (
    <div className="py-3">
      <CatalogoVerificarPersona
        show={mostrarCatalogo}
        onHideCancelaCatActi={abrirCatalogo}
        onHideAceptaCat={aceptarInfoCat}
      />

      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <Dimmer active={activate} />

      <div>
        <div className="container col-md-12">
          <div className="container col-md-12 py-2 card">
            <div className="col-md-12 row m-0">
              <div className="input-group input-group-sm mb-3 col-md-2">
                <span className="input-group-text" id="inputGroup-sizing-sm">
                  {" "}
                  Código:
                </span>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  disabled
                  ref={txtPrefactura}
                />
                <button
                  type="button"
                  disabled={
                    verificacion === 1 || verificacion === 2 ? true : false
                  }
                  ref={btnBuscar}
                  onClick={abrirCatalogo}
                  className="btn btn-sm btn-info "
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>

              <div className="col-md-5">
                <h3 className="text-center fw-bold">
                  {verificacion === 0
                    ? "Proceso de Consulta"
                    : verificacion === 1
                    ? "Proceso de Verificacion"
                    : verificacion === 2
                    ? "Proceso de Rechazo"
                    : ""}{" "}
                </h3>
              </div>

              <div className="col-md-5 row m-0">
                <div className="col-3 ml-auto px-0">
                  <button
                    ref={txtAccion}
                    type="button"
                    disabled={disabletbtn.consultar}
                    onClick={accion(0)}
                    className="btn btn-sm btn-info rounded-pill"
                  >
                    <i className="fas fa-eye"> Consultar</i>
                  </button>
                </div>
                <div className="col-3 ml-auto px-0">
                  <button
                    type="button"
                    disabled={disabletbtn.verificar}
                    onClick={rechazarVerificar(1)}
                    className="btn btn-sm btn-success rounded-pill"
                  >
                    <i className="fas fa-check-circle"> Verificar</i>
                  </button>
                </div>
                <div className="col-3 ml-auto px-0">
                  <button
                    ref={txtEdit}
                    type="button"
                    disabled={disabletbtn.editar}
                    onClick={editar(5)}
                    className="btn btn-sm btn-warning rounded-pill col-10"
                  >
                    <i className="fas fa-edit"> Editar</i>
                  </button>
                </div>
                <div className="col-3 ml-auto px-0">
                  <button
                    type="button"
                    disabled={disabletbtn.rechazar}
                    onClick={rechazarVerificar(2)}
                    className="btn btn-sm btn-danger rounded-pill"
                  >
                    <i className="fas fa-window-close"> Rechazar</i>
                  </button>
                </div>
              </div>
            </div>

            <div className="col-md-12 py-2"></div>

            <fieldset className="row border-azul rounded mx-auto col-md-12">
              <legend className="float-none m-0 w-auto">
                Datos del Verificador
              </legend>

              <div className="col-md-2">
                <div className="input-group input-group-sm">
                  <label className="form-label fw-bold">Código:</label> &nbsp;{" "}
                  {idusuario ? idusuario : ""}
                </div>
              </div>

              <div className="col-md-6">
                <div className="input-group input-group-sm">
                  <label className="form-label fw-bold">
                    Nombres y Apellidos:
                  </label>{" "}
                  &nbsp;{" "}
                  {usuario
                    ? usuario.nombres.trim() + " " + usuario.apellidos.trim()
                    : liquidador}
                </div>
              </div>

              <div className="col-md-2">
                <div className="input-group input-group-sm col-7 ml-auto">
                  <label className="form-label fw-bold">Fecha:</label> &nbsp;{" "}
                  {fechaVerifi ? moment(fechaVerifi).format("YYYY-MM-DD") : ""}
                </div>
              </div>

              {select3 === "0" && (
                <div className="input-group input-group-sm mb-2 col-md-2 px-0">
                  <span className="input-group-text" id="inputGroup-sizing-sm">
                    {" "}
                    Tipo de Impuesto:
                  </span>
                  <select
                    name=""
                    disabled={
                      verificacion === 0 ||
                      verificacion === "" ||
                      verificacion === 5
                        ? true
                        : false
                    }
                    ref={cmbTipoImpuesto}
                    onChange={handlecmbTipoImpuesto}
                    className="form-select text-center"
                  >
                    {tipoImpuesto &&
                      tipoImpuesto.map((impu) => (
                        <option
                          key={impu.idtipoimpuesto}
                          value={impu.idtipoingreso}
                        >
                          {impu.descripcion.trim()}
                        </option>
                      ))}
                  </select>
                </div>
              )}

              {select3 === "1" && (
                <div className="col-md-2 px-0">
                  <div className="input-group input-group-sm">
                    <label className="form-label fw-bold">
                      Tipo de Impuesto:
                    </label>{" "}
                    &nbsp; {idtipoingreso}
                  </div>
                </div>
              )}
            </fieldset>

            <div className="col-md-12 py-2"></div>

            <fieldset className="row border-azul rounded mx-auto col-md-12">
              <legend className="float-none m-0 w-auto">Movimientos Web</legend>

              <div className="row m-0 col-12 py-2">
                <div className="col-sm-2 col-12">
                  <input
                    type="text"
                    onChange={handleSearch}
                    className="form-control form-control-sm rounded-pill"
                    placeholder="Buscar"
                  />
                </div>

                <div className="row m-0 col-sm-10 col-12">
                  <div className="col-sm-1"></div>
                  <div className="form-check col-sm-2">
                    <input
                      className="form-check-input"
                      name="radioBanco"
                      value="1"
                      id="radioSi"
                      defaultChecked={true}
                      ref={radioTodosBancos}
                      onChange={onChecks}
                      disabled={
                        verificacion === 0 ||
                        verificacion === "" ||
                        verificacion === 5
                          ? true
                          : false
                      }
                      type="radio"
                    />
                    <label className="form-check-label" htmlFor="todos1">
                      Todos los Bancos
                    </label>
                  </div>
                  <div className="form-check col-sm-2">
                    <input
                      className="form-check-input"
                      name="radioBanco"
                      value="2"
                      id="radioNo"
                      disabled={
                        verificacion === 0 ||
                        verificacion === "" ||
                        verificacion === 5
                          ? true
                          : false
                      }
                      ref={radioSeleccionarBanco}
                      onChange={onChecks}
                      type="radio"
                    />
                    <label className="form-check-label" htmlFor="todos2">
                      Seleccionar Banco
                    </label>
                  </div>

                  {select === "1" && (
                    <div className="col-md-7">
                      <select
                        name=""
                        ref={cmbCuentaBan}
                        style={{ marginBottom: "5px" }}
                        className="form-control form-control-sm"
                        onChange={handlecmbCuentaBancaria}
                      >
                        <option key="0" value="0">
                          Seleccione Banco
                        </option>
                        {cuentaBancaria &&
                          cuentaBancaria.map((cta) => (
                            <option
                              key={cta.idcuentabancaria}
                              value={cta.idcuentabancaria}
                            >
                              {cta.nombre + " " + cta.cuentabancaria}
                            </option>
                          ))}
                      </select>
                    </div>
                  )}
                </div>

                <div className="col-2"></div>
                <div className="row m-0 col-sm-10 col-12">
                  <div className="col-sm-1"></div>
                  <div className="form-check col-sm-2">
                    <input
                      className="form-check-input"
                      name="radiofecha"
                      value="1"
                      id="radioSi"
                      disabled={
                        verificacion === 0 ||
                        verificacion === "" ||
                        verificacion === 5
                          ? true
                          : false
                      }
                      defaultChecked={true}
                      ref={radioTodosDias}
                      onChange={onChecks}
                      type="radio"
                    />
                    <label className="form-check-label" htmlFor="exampleRadi4">
                      Todos
                    </label>
                  </div>
                  <div className="form-check col-sm-2">
                    <input
                      className="form-check-input"
                      name="radiofecha"
                      value="2"
                      id="radioNo"
                      disabled={
                        verificacion === 0 ||
                        verificacion === "" ||
                        verificacion === 5
                          ? true
                          : false
                      }
                      ref={radioSeleccionarFecha}
                      onChange={onChecks}
                      type="radio"
                    />
                    <label className="form-check-label" htmlFor="exampleRadi5">
                      Por Fecha
                    </label>
                  </div>

                  {select2 === "1" && (
                    <div className="col-sm-7 row m-0">
                      <div className="input-group input-group-sm col-sm-3 px-0">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          Desde:
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          aria-label="Sizing example input"
                          name="fecha"
                          ref={txtFechaDesde}
                          max={moment(fechaSistema).format("YYYY-MM-DD")}
                          id="inputFechaDesde"
                          defaultValue={moment(fechaSistema).format(
                            "YYYY-MM-DD"
                          )}
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                          aria-describedby="inputGroup-sizing-sm"
                        />
                      </div>
                      <div className="input-group input-group-sm col-sm-3 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          Hasta:
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          aria-label="Sizing example input"
                          name="fecha"
                          ref={txtFechaHasta}
                          max={moment(fechaSistema).format("YYYY-MM-DD")}
                          id="inputFechaHasta"
                          defaultValue={moment(fechaSistema).format(
                            "YYYY-MM-DD"
                          )}
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                          aria-describedby="inputGroup-sizing-sm"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <TblContainer
                container={{ height: 350, width: "100%", overflow: "auto" }}
              >
                <TblHead />
                <TableBody>
                  {filterFn.fn(records).map((row) => {
                    const isItemSelected = isSelected(
                      row.nrofactura.trim() +
                        row.periodo.trim() +
                        row.nrodocumento.trim() +
                        row.monto.toString().trim()
                    );
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={
                          row.nrofactura.trim() +
                          row.periodo.trim() +
                          row.nrodocumento.trim() +
                          row.monto.toString().trim()
                        }
                        selected={isItemSelected}
                      >
                        <TableCell
                          className="align-middle"
                          style={{
                            textAlign: "center",
                            padding: 0,
                            borderRight: "#cbced1 1px solid",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={isItemSelected}
                            disabled={desabilitarRows2}
                            onChange={(event) =>
                              handleClick(
                                event,
                                row.nrofactura.trim() +
                                  row.periodo.trim() +
                                  row.nrodocumento.trim() +
                                  row.monto.toString().trim(),
                                row.nrofactura.trim()
                              )
                            }
                          />
                        </TableCell>
                        <TableCell
                          className="align-middle"
                          style={{
                            padding: 0,
                            paddingLeft: 5,
                            textAlign: "left",
                            fontSize: "10px",
                            borderRight: "#cbced1 1px solid",
                          }}
                        >
                          {row.cuentabancaria.trim()}
                        </TableCell>
                        <TableCell
                          className="align-middle"
                          style={{
                            padding: 0,
                            textAlign: "center",
                            fontSize: "10px",
                            borderRight: "#cbced1 1px solid",
                          }}
                        >
                          {row.nrodocumento.trim()}
                        </TableCell>
                        <TableCell
                          className="align-middle"
                          style={{
                            padding: 0,
                            textAlign: "center",
                            fontSize: "10px",
                            borderRight: "#cbced1 1px solid",
                          }}
                        >
                          {row.tipo}
                        </TableCell>
                        <TableCell
                          className="align-middle"
                          style={{
                            padding: 0,
                            textAlign: "center",
                            fontSize: "10px",
                            borderRight: "#cbced1 1px solid",
                          }}
                        >
                          {moment(row.fecha).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell
                          className="align-middle"
                          style={{
                            padding: 0,
                            paddingRight: 5,
                            textAlign: "right",
                            borderRight: "#cbced1 1px solid",
                            fontSize: "10px",
                          }}
                        >
                          {formatMoneda(
                            row.monto.toString().replace(".", ","),
                            ",",
                            ".",
                            2
                          )}
                        </TableCell>
                        <TableCell
                          className="align-middle"
                          style={{
                            padding: 0,
                            textAlign: "center",
                            fontSize: "10px",
                            borderRight: "#cbced1 1px solid",
                          }}
                        >
                          {row.nrofactura.trim()}
                        </TableCell>
                        <TableCell
                          className="align-middle"
                          style={{
                            padding: 0,
                            paddingLeft: 5,
                            textAlign: "left",
                            fontSize: "10px",
                            borderRight: "#cbced1 1px solid",
                          }}
                        >
                          {row.contribuyente}{" "}
                        </TableCell>
                        <TableCell
                          className="align-middle"
                          style={{
                            padding: 0,
                            textAlign: "center",
                            fontSize: "10px",
                            borderRight: "#cbced1 1px solid",
                          }}
                        >
                          {row.periodo.trim()}
                        </TableCell>
                        <TableCell
                          className="align-middle"
                          style={{
                            padding: 0,
                            textAlign: "center",
                            fontSize: "10px",
                            borderRight: "#cbced1 1px solid",
                          }}
                        >
                          {moment(row.fechaoperacion).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell
                          className="align-middle"
                          align="center"
                          style={{ padding: 2, textAlign: "center" }}
                        >
                          <button
                            disabled={desabilitarRows}
                            onClick={editarMovimiento(row)}
                            className="btn btn-xs btn-warning rounded-circle"
                          >
                            <i className="fas fa-edit"> </i>{" "}
                          </button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </TblContainer>

              <div className="row col-md-12 d-flex justify-content-end row align-items-center py-2">
                <div className="input-group input-group-sm col-md-2 ">
                  <span className="input-group-text" id="inputGroup-sizing-sm">
                    Total:
                  </span>
                  <input
                    type="text"
                    readOnly
                    ref={txtTotal}
                    className="form-control form-control-sm text-right"
                    defaultValue="0,00"
                    id="inputTotal"
                  />
                </div>

                <div className="col-md-4 d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-sm btn-primary rounded-pill mx-2 "
                    disabled={activo2 === true ? true : false}
                    onClick={handleBtnImprimir}
                  >
                    <i className="fas fa-print"> Imprimir</i>
                  </button>
                  <button
                    type="button"
                    onClick={onChangeValidar}
                    disabled={activo === true ? true : false}
                    className="btn btn-sm btn-success rounded-pill mx-2 "
                  >
                    <i className="fas fa-check-circle"> Aceptar</i>
                  </button>
                  <button
                    type="button"
                    onClick={cancelar}
                    disabled={activo1 === true ? true : false}
                    className="btn btn-sm btn-danger rounded-pill mx-2 "
                  >
                    <i className="fas fa-window-close"> Cancelar</i>
                  </button>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
      <ActualizarPagosWeb
        show={mostrar5}
        onHideCancela={cerrarModalActualizar}
        onHideAcepta={validarActuPagoW}
        cuentabancaria={cuentaBancaria}
        data={data}
        deshabilitado={false}
        tipopago={tipoPago}
        operacion={operacion}
      />
    </div>
  );
}

export default TablaVerificarPagos;



// WEBPACK FOOTER //
// ./src/components/ingresos/tablaVerificarPagos.js